import React from 'react';
import { motion } from 'framer-motion';

export default function WhyUsSection({ brand, whyForYou }) {
  return (
    <section className="why-us" id="why-us">
      <div className="why-us-inner">
        <motion.div
          className="why-us-head"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
        >
          <div className="why-us-kicker">Why {brand}?</div>
          <h2>Carefully raised. Easy to love.</h2>
          <p>
            Small companions with big hearts — matched thoughtfully, handled gently, and supported from the first
            message.
          </p>
        </motion.div>

        <div className="why-us-rows">
          {whyForYou.map((item, idx) => (
            <motion.div
              key={item.title}
              className={`why-us-row ${idx % 2 === 1 ? 'is-reversed' : ''}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: idx * 0.03 }}
              whileHover={{ y: -4 }}
            >
              <div className="why-us-row-media" aria-hidden="true">
                <div className="why-us-chip">{String(idx + 1).padStart(2, '0')}</div>
                <div className="why-us-photo">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
              </div>
              <div className="why-us-row-copy">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
